import React, { useState } from "react";
import productData from "../data/products.json";
import ProductCard from "./ProductCard";

const Productlistcard = () => {
  const [products] = useState(
    productData.products.filter((product) => product.productstatus === "Active")
  );

  return (
    <section className="py-4 px-2 md:px-8 lg:px-16 bg-white">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 md:gap-8">
        {products.map((product) => (
          <div key={product.id} className="mt-8">
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Productlistcard;
